import React, { useState, useEffect } from "react";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  IconButton,
  CircularProgress,
  colors,
  Modal,
  Box,
  Button,
  Typography,
} from "@mui/material";
import { FaArrowLeftLong } from "react-icons/fa6";
import { axiosInstance } from "../../axiosInstance";
import { data, Link, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import NoImageFound from "../../assets/images/No-Image-found.png";

const columns = [
  { id: "medicine_id", label: "Medicine ID", minWidth: 170, align: "center" },
  {
    id: "medicine_name",
    label: "Medicine Name",
    minWidth: 170,
    align: "center",
  },
  { id: "quantity", label: "Quantity", minWidth: 170, align: "center" },
  // {
  //   id: "amount",
  //   label: "Amount",
  //   minWidth: 170,
  //   align: "center",
  // },
];

function createData(medicine_id, medicine_name, quantity) {
  return {
    medicine_id,
    medicine_name,
    quantity,
  };
}

const rows = [
  createData("Med001", "Paracetamol", "10 nos", "₹200"),
  createData("Med002", "Ibuprofen", "20 nos", "₹400"),
  createData("Med003", "Diclofenac", "10 nos", "₹600"),
];

const packagecolumns = [
  { id: "type_of_pack", label: "Package Type", minWidth: 170, align: "center" },
  {
    id: "no_of_pack",
    label: "No. of Packs",
    minWidth: 170,
    align: "center",
  },
  {
    id: "size_l",
    label: "Size In Length",
    minWidth: 170,
    align: "center",
  },
  {
    id: "size_w",
    label: "Size In Width",
    minWidth: 170,
    align: "center",
  },
  {
    id: "size_h",
    label: "Size In Height",
    minWidth: 170,
    align: "center",
  },
  { id: "weight", label: "Weight", minWidth: 170, align: "center" },
];

function createDataPackage(
  type_of_pack,
  no_of_pack,
  size_l,
  size_w,
  size_h,
  weight
) {
  return { type_of_pack, no_of_pack, size_l, size_w, size_h, weight };
}

const packagerows = [
  createDataPackage("Bag", "20 nos", "500 gms"),
  createDataPackage("Bag", "20 nos", "500 gms"),
  createDataPackage("Bag", "20 nos", "500 gms"),
];

const transactioncolumns = [
  { id: "payment_id", label: "Payment ID", minWidth: 170, align: "center" },
  {
    id: "transaction_type",
    label: "Transaction Type",
    minWidth: 170,
    align: "center",
  },
  {
    id: "invoice_amount",
    label: "Invoice Amount",
    minWidth: 170,
    align: "center",
  },
  {
    id: "convience_fee",
    label: "Convenience Fee",
    minWidth: 170,
    align: "center",
  },
  { id: "paid_by", label: "Paid by", minWidth: 170, align: "center" },
];
function createDataTransaction(
  payment_id,
  transaction_type,
  invoice_amount,
  convience_fee,
  paid_by
) {
  return {
    payment_id,
    transaction_type,
    invoice_amount,
    convience_fee,
    paid_by,
  };
}

const transactionrows = [
  createDataTransaction("Pay001", "Invoice Fee", "₹15000", "₹40", "Retailer"),
  createDataTransaction("Pay002", "Invoice Fee", "₹15000", "₹40", "Retailer"),
  createDataTransaction("Pay003", "Invoice Fee", "₹15000", "₹40", "Retailer"),
  createDataTransaction("Pay004", "Invoice Fee", "₹15000", "₹40", "Retailer"),
];

export const TransactionDetailesRyder = () => {
  const { delivery_id } = useParams();

  const navigate = useNavigate();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(20);

  const [transactionDetailesRyder, setTransactionDetailesRyder] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const [openModal, setOpenModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState("");

  // ✅ Use correct keys from API response
  const invoices = transactionDetailesRyder?.invoice || [];
  const medicines = transactionDetailesRyder?.medicines || [];
  const packages = transactionDetailesRyder?.package || [];
  const transactions = transactionDetailesRyder?.transaction || [];

  const leftInvoices = [];
  const rightInvoices = [];

  // Split invoices into left and right columns
  invoices.forEach((invoice, index) => {
    if (invoice.file_url) {
      if (index % 2 === 0) {
        leftInvoices.push({ ...invoice, label: `Document ${index + 1}` });
      } else {
        rightInvoices.push({ ...invoice, label: `Document ${index + 1}` });
      }
    }
  });

  const fetchTransactionDetailesRyder = async () => {
    if (!delivery_id) {
      setTransactionDetailesRyder({});
      return;
    }

    setLoading(true);
    setError("");
    try {
      const res = await axiosInstance.get(
        `/admin/transaction-rider-order-details/${delivery_id}`
      );
      console.log("transaction-rider-order-details List response:", res.data);
      if (res.data.status === "success") {
        setTransactionDetailesRyder(res.data.data || {});
      } else {
        setError("Failed to fetch transaction-rider-order-details data.");
      }
    } catch (err) {
      console.error(
        "❌ Error fetching transaction-rider-order-details data:",
        err
      );
      setError("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTransactionDetailesRyder();
  }, []);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };
  return (
    <>
      {" "}
      <div>
        <div className="arrowNavigation">
          <FaArrowLeftLong
            style={{ cursor: "pointer" }}
            onClick={() => navigate(`/transaction-ryder`)}
          />
          <div>Order Detail:</div>
          <div>{""}</div>
        </div>
        {/* medicne table  */}
        <div>
          <div className="admin-listText mb-2">Medicine Details</div>

          <Paper sx={{ width: "100%", overflow: "hidden" }}>
            <TableContainer sx={{ maxHeight: 440 }} className="Table-container">
              <Table stickyHeader aria-label="sticky table">
                <TableHead>
                  <TableRow>
                    {columns.map((column) => (
                      <TableCell
                        key={column.id}
                        align={column.align}
                        style={{ minWidth: column.minWidth }}
                        className="table-header"
                      >
                        {column.label}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {loading ? (
                    <TableRow>
                      <TableCell colSpan={columns.length} align="center">
                        <CircularProgress />
                      </TableCell>
                    </TableRow>
                  ) : medicines.length > 0 ? (
                    medicines
                      .slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )
                      .map((row, index) => (
                        <TableRow
                          className="table-row"
                          hover
                          role="checkbox"
                          tabIndex={-1}
                          key={index}
                          sx={{
                            backgroundColor:
                              index % 2 === 1 ? "#E7F0F9" : "white",
                          }}
                        >
                          {columns.map((column) => {
                            const value = row[column.id];
                            return (
                              <TableCell
                                key={column.id}
                                align={column.align}
                                className={`${column.id}-column tableCelldata`}
                                sx={{ cursor: "pointer" }}
                              >
                                {value}
                              </TableCell>
                            );
                          })}
                        </TableRow>
                      ))
                  ) : (
                    <TableRow>
                      <TableCell
                        colSpan={columns.length}
                        align="center"
                        style={{ padding: "40px 0" }}
                      >
                        No Data Available
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              rowsPerPageOptions={[20, 50, 100, 500, 1000, 2000, 5000]}
              component="div"
              count={medicines.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </Paper>
        </div>

        {/* package details table  */}
        <div>
          <div className="admin-listText my-3">Package Details</div>

          <Paper sx={{ width: "100%", overflow: "hidden" }}>
            <TableContainer sx={{ maxHeight: 440 }} className="Table-container">
              <Table stickyHeader aria-label="sticky table">
                <TableHead>
                  <TableRow>
                    {packagecolumns.map((column) => (
                      <TableCell
                        key={column.id}
                        align={column.align}
                        style={{ minWidth: column.minWidth }}
                        className="table-header"
                      >
                        {column.label}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {loading ? (
                    <TableRow>
                      <TableCell colSpan={packagecolumns.length} align="center">
                        <CircularProgress />
                      </TableCell>
                    </TableRow>
                  ) : packages.length > 0 ? (
                    packages
                      .slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )
                      .map((row, index) => (
                        <TableRow
                          className="table-row"
                          hover
                          role="checkbox"
                          tabIndex={-1}
                          key={index}
                          sx={{
                            backgroundColor:
                              index % 2 === 1 ? "#E7F0F9" : "white",
                          }}
                        >
                          {packagecolumns.map((column) => {
                            const value = row[column.id] || "-";
                            return (
                              <TableCell
                                key={column.id}
                                align={column.align}
                                className={`${column.id}-column tableCelldata`}
                              >
                                {value}
                              </TableCell>
                            );
                          })}
                        </TableRow>
                      ))
                  ) : (
                    <TableRow>
                      <TableCell
                        colSpan={packagecolumns.length}
                        align="center"
                        style={{ padding: "40px 0" }}
                      >
                        No Data Available
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              rowsPerPageOptions={[20, 50, 100, 500, 1000, 2000, 5000]}
              component="div"
              count={packages.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </Paper>
        </div>

        {/* invoice details  */}
        <div>
          <div className="admin-listText my-3">Invoice Details</div>

          <div className="general-container">
            <div className="general-left">
              {leftInvoices.map((invoice, index) => (
                <div
                  key={`left-${index}`}
                  className="editWholesaler-field"
                  style={{ marginBottom: "16px" }}
                >
                  <label>{invoice.label}</label>
                  <div>
                    <Button
                      variant="outlined"
                      onClick={() => {
                        setSelectedImage(invoice.file_url);
                        setOpenModal(true);
                      }}
                    >
                      {invoice.label}
                    </Button>
                  </div>
                </div>
              ))}
            </div>

            <div className="general-right">
              {rightInvoices.map((invoice, index) => (
                <div
                  key={`right-${index}`}
                  className="editWholesaler-field"
                  style={{ marginBottom: "16px" }}
                >
                  <label>{invoice.label}</label>
                  <div>
                    <Button
                      variant="outlined"
                      onClick={() => {
                        setSelectedImage(invoice.file_url);
                        setOpenModal(true);
                      }}
                    >
                      {invoice.label}
                    </Button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* transaction details  */}
        <div>
          <div className="admin-listText my-3">Transaction Details</div>

          <Paper sx={{ width: "100%", overflow: "hidden" }}>
            <TableContainer sx={{ maxHeight: 440 }} className="Table-container">
              <Table stickyHeader aria-label="sticky table">
                <TableHead>
                  <TableRow>
                    {transactioncolumns.map((column) => (
                      <TableCell
                        key={column.id}
                        align={column.align}
                        style={{ minWidth: column.minWidth }}
                        className="table-header"
                      >
                        {column.label}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {loading ? (
                    <TableRow>
                      <TableCell
                        colSpan={transactioncolumns.length}
                        align="center"
                      >
                        <CircularProgress />
                      </TableCell>
                    </TableRow>
                  ) : transactions.length > 0 ? (
                    transactions
                      .slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )
                      .map((row, index) => (
                        <TableRow
                          className="table-row"
                          hover
                          role="checkbox"
                          tabIndex={-1}
                          key={index}
                          sx={{
                            backgroundColor:
                              index % 2 === 1 ? "#E7F0F9" : "white",
                          }}
                        >
                          {transactioncolumns.map((column) => {
                            const value = row[column.id] || "-";
                            return (
                              <TableCell
                                key={column.id}
                                align={column.align}
                                className={`${column.id}-column tableCelldata`}
                              >
                                {value}
                              </TableCell>
                            );
                          })}
                        </TableRow>
                      ))
                  ) : (
                    <TableRow>
                      <TableCell
                        colSpan={transactioncolumns.length}
                        align="center"
                        style={{ padding: "40px 0" }}
                      >
                        No Data Available
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              rowsPerPageOptions={[20, 50, 100, 500, 1000, 2000, 5000]}
              component="div"
              count={transactions.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </Paper>
        </div>
      </div>
      <Modal
        open={openModal}
        onClose={() => setOpenModal(false)}
        aria-labelledby="invoice-image-modal"
        aria-describedby="invoice-image-preview"
      >
        <Box
          sx={{
            position: "relative",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 500,
            bgcolor: "background.paper",
            borderRadius: 2,
            boxShadow: 24,
            p: 4,
          }}
        >
          {/* Close Button */}
          <button
            onClick={() => setOpenModal(false)}
            style={{
              position: "absolute",
              top: 10,
              right: 15,
              background: "transparent",
              border: "none",
              fontSize: "1.5rem",
              cursor: "pointer",
            }}
          >
            &times;
          </button>

          <h3 id="toggle-status-title">Preview the document</h3>
          <hr />
          <div style={{ textAlign: "center" }}>
            {selectedImage ? (
              <img
                src={selectedImage || NoImageFound}
                alt="Document"
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = NoImageFound;
                }}
                style={{
                  width: "100%",
                  maxHeight: "400px",
                  objectFit: "contain",
                  border: "1px solid #ccc",
                  borderRadius: "8px",
                }}
              />
            ) : (
              <div>No document to display.</div>
            )}
          </div>
          <hr />
        </Box>
      </Modal>
    </>
  );
};
